export default "__VITE_ASSET__0a933606__"